import { Modules } from 'src/guards/modules';

function resolveToModuleKey(token: string): string | null {
  const t = token.trim();
  if (!t) return null;
  const byKey = Modules.find((m) => m.key === t);
  if (byKey) return byKey.key;
  const byValue = Modules.find((m) => m.value === t);
  if (byValue) return byValue.key;
  return null;
}

/**
 * Map `permissions.modules` from login API to canonical module keys (by `key` or enum `value` string).
 * No merging or auto-expansion — list must match what the backend grants (granular CMS per module).
 */
export function normalizeLoginModules(raw: unknown): string[] {
  if (!raw || !Array.isArray(raw)) return [];

  const keys = new Set<string>();

  for (const item of raw) {
    if (item == null) continue;

    if (typeof item === 'object' && !Array.isArray(item)) {
      const o = item as Record<string, unknown>;
      const k = o.key != null ? String(o.key).trim() : '';
      const v = o.value != null ? String(o.value).trim() : '';
      const resolved = resolveToModuleKey(k) || resolveToModuleKey(v);
      if (resolved) keys.add(resolved);
      continue;
    }

    const s = String(item).trim();
    if (!s) continue;
    const resolved = resolveToModuleKey(s);
    if (resolved) keys.add(resolved);
    else keys.add(s);
  }

  return Array.from(keys);
}
